// @flow
export const filterCount = (num: number): string => {
    return num && num > 0 ? `(${num})` : '';
};
